import request from '@/utils/request'
const apiPath = '/sys/cityCompany'
const cityCompanyApi = {
  /**
   * 新增【城市公司】
   */
  create(data) {
    return request.post(`${apiPath}`, data)
  },
  /**
   * 修改【城市公司】
   */
  update(data) {
    return request.put(`${apiPath}`, data)
  },
  /**
   * 分页查询【城市公司列表】
   */
  fetchList(query) {
    return request.get(`${apiPath}/listNew`, {
      params: query
    })
  },
  /**
   * 查询【城市公司】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 查看【城市公司】选项
   */
  getOption(query) {
    return request.get(`${apiPath}/options`, {
      params: query
    })
  },
  /**
   * 下拉框列表查询【大区】
   */
  getListForMini(query) {
    return request.get(`${apiPath}/findCityCompanyCustomerAreaList`, {
      params: query
    })
  },
  /**
   * 查询单个城市公司大区明细信息分页列表【城市公司】
   */
  getRegionList(query) {
    return request.get(`${apiPath}/findTheCityCompanyAreaListBYPage`, {
      params: query
    })
  },
  /**
   * 删除单个【城市公司管辖大区】
   */
  deleteById(query) {
    return request.delete('/sys/cityCompanyArea/deleteByCustomerId', {
      params: query
    })
  },
  getAccount(query){
    return request.get(`${apiPath}/findCityCompanyAccountPageList`, {
      params: query
    })
  },
  // 导出
  exportExcel(data) {
    return request.post(apiPath + '/ManageExportCityCompany', data)
  },
  // 状态修改
  cityCompanyEnableDisable(data){
    return request.post(apiPath + '/cityCompanyEnableDisable', data)
  },
  // 城市公司销售统计导出
  exportCityCompanyTotal(data){
     return request.post(apiPath + '/ExportCityCompanyTotal', data)
  },
  findCityCompanyTotalByPage(query){
    return request.get(apiPath+'/findCityCompanyTotalByPage', {
      params: query
    })
  },
}
export default cityCompanyApi
